/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { JwtMasterForbiddenDto } from '../../src/model';
// @ts-ignore
import type { JwtMasterUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { MasterDeleteAdminUserInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { MasterDeleteAdminUserNotFoundDto } from '../../src/model';
// @ts-ignore
import type { MasterGetAdminUserInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { MasterGetAdminUserNotFoundDto } from '../../src/model';
// @ts-ignore
import type { MasterGetAdminUserOkDto } from '../../src/model';
// @ts-ignore
import type { MasterGetAdminUsersInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { MasterGetAdminUsersOkDto } from '../../src/model';
// @ts-ignore
import type { MasterPatchAdminUserBadRequestDto } from '../../src/model';
// @ts-ignore
import type { MasterPatchAdminUserInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { MasterPatchAdminUserNotFoundPermissionsDto } from '../../src/model';
// @ts-ignore
import type { MasterPatchAdminUserNotFoundUserDto } from '../../src/model';
// @ts-ignore
import type { MasterPatchAdminUserReqBodyDto } from '../../src/model';
/**
 * MasterAdminUsersApi - axios parameter creator
 * @export
 */
export const MasterAdminUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 마스터 관리자 어드민 유저 개별 조회
         * @param {string} adminUserUuid 어드민 유저 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAdminUserControllerAdminGetAdminUser: async (adminUserUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserUuid' is not null or undefined
            assertParamExists('masterAdminUserControllerAdminGetAdminUser', 'adminUserUuid', adminUserUuid)
            const localVarPath = `/master/admin-users/{adminUserUuid}`
                .replace(`{${"adminUserUuid"}}`, encodeURIComponent(String(adminUserUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 마스터 관리자 어드민 유저 삭제
         * @param {string} adminUserUuid 어드민 유저 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAdminUserControllerMasterDeleteAdminUser: async (adminUserUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserUuid' is not null or undefined
            assertParamExists('masterAdminUserControllerMasterDeleteAdminUser', 'adminUserUuid', adminUserUuid)
            const localVarPath = `/master/admin-users/{adminUserUuid}`
                .replace(`{${"adminUserUuid"}}`, encodeURIComponent(String(adminUserUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 마스터 관리자 어드민 유저 전체 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {MasterAdminUserControllerMasterGetAdminUsersSortEnum} [sort] 정렬 기준
         * @param {boolean} [isLoginRestrict] 로그인 제한
         * @param {string} [keyword] 검색어
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAdminUserControllerMasterGetAdminUsers: async (page?: number, limit?: number, sort?: MasterAdminUserControllerMasterGetAdminUsersSortEnum, isLoginRestrict?: boolean, keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/master/admin-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (isLoginRestrict !== undefined) {
                localVarQueryParameter['isLoginRestrict'] = isLoginRestrict;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 마스터 관리자 어드민 유저 수정
         * @param {string} adminUserUuid 어드민 유저 uuid
         * @param {MasterPatchAdminUserReqBodyDto} masterPatchAdminUserReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAdminUserControllerMasterPatchAdminUser: async (adminUserUuid: string, masterPatchAdminUserReqBodyDto: MasterPatchAdminUserReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserUuid' is not null or undefined
            assertParamExists('masterAdminUserControllerMasterPatchAdminUser', 'adminUserUuid', adminUserUuid)
            // verify required parameter 'masterPatchAdminUserReqBodyDto' is not null or undefined
            assertParamExists('masterAdminUserControllerMasterPatchAdminUser', 'masterPatchAdminUserReqBodyDto', masterPatchAdminUserReqBodyDto)
            const localVarPath = `/master/admin-users/{adminUserUuid}`
                .replace(`{${"adminUserUuid"}}`, encodeURIComponent(String(adminUserUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(masterPatchAdminUserReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterAdminUsersApi - functional programming interface
 * @export
 */
export const MasterAdminUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterAdminUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 마스터 관리자 어드민 유저 개별 조회
         * @param {string} adminUserUuid 어드민 유저 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterAdminUserControllerAdminGetAdminUser(adminUserUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterGetAdminUserOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterAdminUserControllerAdminGetAdminUser(adminUserUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterAdminUsersApi.masterAdminUserControllerAdminGetAdminUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 마스터 관리자 어드민 유저 삭제
         * @param {string} adminUserUuid 어드민 유저 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterAdminUserControllerMasterDeleteAdminUser(adminUserUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterAdminUserControllerMasterDeleteAdminUser(adminUserUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterAdminUsersApi.masterAdminUserControllerMasterDeleteAdminUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 마스터 관리자 어드민 유저 전체 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {MasterAdminUserControllerMasterGetAdminUsersSortEnum} [sort] 정렬 기준
         * @param {boolean} [isLoginRestrict] 로그인 제한
         * @param {string} [keyword] 검색어
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterAdminUserControllerMasterGetAdminUsers(page?: number, limit?: number, sort?: MasterAdminUserControllerMasterGetAdminUsersSortEnum, isLoginRestrict?: boolean, keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterGetAdminUsersOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterAdminUserControllerMasterGetAdminUsers(page, limit, sort, isLoginRestrict, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterAdminUsersApi.masterAdminUserControllerMasterGetAdminUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 마스터 관리자 어드민 유저 수정
         * @param {string} adminUserUuid 어드민 유저 uuid
         * @param {MasterPatchAdminUserReqBodyDto} masterPatchAdminUserReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterAdminUserControllerMasterPatchAdminUser(adminUserUuid: string, masterPatchAdminUserReqBodyDto: MasterPatchAdminUserReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterAdminUserControllerMasterPatchAdminUser(adminUserUuid, masterPatchAdminUserReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterAdminUsersApi.masterAdminUserControllerMasterPatchAdminUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MasterAdminUsersApi - factory interface
 * @export
 */
export const MasterAdminUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterAdminUsersApiFp(configuration)
    return {
        /**
         * 
         * @summary 마스터 관리자 어드민 유저 개별 조회
         * @param {MasterAdminUsersApiMasterAdminUserControllerAdminGetAdminUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAdminUserControllerAdminGetAdminUser(requestParameters: MasterAdminUsersApiMasterAdminUserControllerAdminGetAdminUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<MasterGetAdminUserOkDto> {
            return localVarFp.masterAdminUserControllerAdminGetAdminUser(requestParameters.adminUserUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 마스터 관리자 어드민 유저 삭제
         * @param {MasterAdminUsersApiMasterAdminUserControllerMasterDeleteAdminUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAdminUserControllerMasterDeleteAdminUser(requestParameters: MasterAdminUsersApiMasterAdminUserControllerMasterDeleteAdminUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.masterAdminUserControllerMasterDeleteAdminUser(requestParameters.adminUserUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 마스터 관리자 어드민 유저 전체 조회
         * @param {MasterAdminUsersApiMasterAdminUserControllerMasterGetAdminUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAdminUserControllerMasterGetAdminUsers(requestParameters: MasterAdminUsersApiMasterAdminUserControllerMasterGetAdminUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MasterGetAdminUsersOkDto> {
            return localVarFp.masterAdminUserControllerMasterGetAdminUsers(requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.isLoginRestrict, requestParameters.keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 마스터 관리자 어드민 유저 수정
         * @param {MasterAdminUsersApiMasterAdminUserControllerMasterPatchAdminUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAdminUserControllerMasterPatchAdminUser(requestParameters: MasterAdminUsersApiMasterAdminUserControllerMasterPatchAdminUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.masterAdminUserControllerMasterPatchAdminUser(requestParameters.adminUserUuid, requestParameters.masterPatchAdminUserReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for masterAdminUserControllerAdminGetAdminUser operation in MasterAdminUsersApi.
 * @export
 * @interface MasterAdminUsersApiMasterAdminUserControllerAdminGetAdminUserRequest
 */
export interface MasterAdminUsersApiMasterAdminUserControllerAdminGetAdminUserRequest {
    /**
     * 어드민 유저 uuid
     * @type {string}
     * @memberof MasterAdminUsersApiMasterAdminUserControllerAdminGetAdminUser
     */
    readonly adminUserUuid: string
}

/**
 * Request parameters for masterAdminUserControllerMasterDeleteAdminUser operation in MasterAdminUsersApi.
 * @export
 * @interface MasterAdminUsersApiMasterAdminUserControllerMasterDeleteAdminUserRequest
 */
export interface MasterAdminUsersApiMasterAdminUserControllerMasterDeleteAdminUserRequest {
    /**
     * 어드민 유저 uuid
     * @type {string}
     * @memberof MasterAdminUsersApiMasterAdminUserControllerMasterDeleteAdminUser
     */
    readonly adminUserUuid: string
}

/**
 * Request parameters for masterAdminUserControllerMasterGetAdminUsers operation in MasterAdminUsersApi.
 * @export
 * @interface MasterAdminUsersApiMasterAdminUserControllerMasterGetAdminUsersRequest
 */
export interface MasterAdminUsersApiMasterAdminUserControllerMasterGetAdminUsersRequest {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof MasterAdminUsersApiMasterAdminUserControllerMasterGetAdminUsers
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof MasterAdminUsersApiMasterAdminUserControllerMasterGetAdminUsers
     */
    readonly limit?: number

    /**
     * 정렬 기준
     * @type {'latest' | 'oldest'}
     * @memberof MasterAdminUsersApiMasterAdminUserControllerMasterGetAdminUsers
     */
    readonly sort?: MasterAdminUserControllerMasterGetAdminUsersSortEnum

    /**
     * 로그인 제한
     * @type {boolean}
     * @memberof MasterAdminUsersApiMasterAdminUserControllerMasterGetAdminUsers
     */
    readonly isLoginRestrict?: boolean

    /**
     * 검색어
     * @type {string}
     * @memberof MasterAdminUsersApiMasterAdminUserControllerMasterGetAdminUsers
     */
    readonly keyword?: string
}

/**
 * Request parameters for masterAdminUserControllerMasterPatchAdminUser operation in MasterAdminUsersApi.
 * @export
 * @interface MasterAdminUsersApiMasterAdminUserControllerMasterPatchAdminUserRequest
 */
export interface MasterAdminUsersApiMasterAdminUserControllerMasterPatchAdminUserRequest {
    /**
     * 어드민 유저 uuid
     * @type {string}
     * @memberof MasterAdminUsersApiMasterAdminUserControllerMasterPatchAdminUser
     */
    readonly adminUserUuid: string

    /**
     * 
     * @type {MasterPatchAdminUserReqBodyDto}
     * @memberof MasterAdminUsersApiMasterAdminUserControllerMasterPatchAdminUser
     */
    readonly masterPatchAdminUserReqBodyDto: MasterPatchAdminUserReqBodyDto
}

/**
 * MasterAdminUsersApi - object-oriented interface
 * @export
 * @class MasterAdminUsersApi
 * @extends {BaseAPI}
 */
export class MasterAdminUsersApi extends BaseAPI {
    /**
     * 
     * @summary 마스터 관리자 어드민 유저 개별 조회
     * @param {MasterAdminUsersApiMasterAdminUserControllerAdminGetAdminUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterAdminUsersApi
     */
    public masterAdminUserControllerAdminGetAdminUser(requestParameters: MasterAdminUsersApiMasterAdminUserControllerAdminGetAdminUserRequest, options?: RawAxiosRequestConfig) {
        return MasterAdminUsersApiFp(this.configuration).masterAdminUserControllerAdminGetAdminUser(requestParameters.adminUserUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 마스터 관리자 어드민 유저 삭제
     * @param {MasterAdminUsersApiMasterAdminUserControllerMasterDeleteAdminUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterAdminUsersApi
     */
    public masterAdminUserControllerMasterDeleteAdminUser(requestParameters: MasterAdminUsersApiMasterAdminUserControllerMasterDeleteAdminUserRequest, options?: RawAxiosRequestConfig) {
        return MasterAdminUsersApiFp(this.configuration).masterAdminUserControllerMasterDeleteAdminUser(requestParameters.adminUserUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 마스터 관리자 어드민 유저 전체 조회
     * @param {MasterAdminUsersApiMasterAdminUserControllerMasterGetAdminUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterAdminUsersApi
     */
    public masterAdminUserControllerMasterGetAdminUsers(requestParameters: MasterAdminUsersApiMasterAdminUserControllerMasterGetAdminUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return MasterAdminUsersApiFp(this.configuration).masterAdminUserControllerMasterGetAdminUsers(requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.isLoginRestrict, requestParameters.keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 마스터 관리자 어드민 유저 수정
     * @param {MasterAdminUsersApiMasterAdminUserControllerMasterPatchAdminUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterAdminUsersApi
     */
    public masterAdminUserControllerMasterPatchAdminUser(requestParameters: MasterAdminUsersApiMasterAdminUserControllerMasterPatchAdminUserRequest, options?: RawAxiosRequestConfig) {
        return MasterAdminUsersApiFp(this.configuration).masterAdminUserControllerMasterPatchAdminUser(requestParameters.adminUserUuid, requestParameters.masterPatchAdminUserReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const MasterAdminUserControllerMasterGetAdminUsersSortEnum = {
    Latest: 'latest',
    Oldest: 'oldest'
} as const;
export type MasterAdminUserControllerMasterGetAdminUsersSortEnum = typeof MasterAdminUserControllerMasterGetAdminUsersSortEnum[keyof typeof MasterAdminUserControllerMasterGetAdminUsersSortEnum];
